import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const returnNetworkProductSchema_ = z.object({
  id: z.string(),
  title: z.string(),
  sku: z.string().nullable(),
  upc: z.string().nullable(),
  hsCode: z.string().nullable(),
  originCountry: z.string().nullable(),
  weightDisplay: z.string().nullable(),
  weightValue: z.number().nullable(),
  weightUnit: z.string().nullable(),
  priceCents: z.number().nullable(),
  currency: z.string().nullable(),
  unitsInStock: z.number(),
  hasManufacturerInfo: z.boolean(),
  manufacturerId: z.string().nullable(),
  manufacturerName: z.string().nullable(),
  isEligible: z.boolean(),
  missingFields: z.array(z.string()),
});
export const returnNetworkProductSchema: z.ZodType<ReturnNetworkProduct> =
  returnNetworkProductSchema_;
export interface ReturnNetworkProduct extends z.infer<
  typeof returnNetworkProductSchema_
> {}

const returnNetworkProductSummarySchema = z.object({
  productCount: z.number(),
  ineligibleCount: z.number(),
});

export const getReturnNetworkProducts = unaryRpc({
  name: "getReturnNetworkProducts" as const,
  input: z.object({
    returnsCenterId: z.string().optional(),
    page: z.number().min(0).optional(),
    pageSize: z.number().min(1).max(200).default(25),
  }),
  output: z.object({
    products: z.array(returnNetworkProductSchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
    summary: returnNetworkProductSummarySchema,
  }),
});

export type ReturnNetworkProductsOutput = z.infer<
  (typeof getReturnNetworkProducts)["output"]
>;

export const getReturnNetworkProductsForExport = unaryRpc({
  name: "getReturnNetworkProductsForExport" as const,
  input: z.object({ returnsCenterId: z.string().optional() }),
  output: z.object({ csv: z.string(), filename: z.string() }),
});

export type ReturnNetworkProductsExportOutput = z.infer<
  (typeof getReturnNetworkProductsForExport)["output"]
>;
